import { Navigate } from "react-router-dom";
import './gallery.css'
import { useEffect, useState } from "react";

function Gallery() {
    const [focusedSrc, setFocusedSrc] = useState("");
    const [focusedIndex, setFocusedIndex] = useState(-1);
    const [loading, setLoading] = useState(false);
    const [numberOfImages, setNumberOfImages] = useState(0)
    const [imageSrcList, setImageSrcList] = useState([{ src: "" }])

    useEffect(() => {
        if (numberOfImages === 0) {
            setLoading(true)
            fetch("/galleryfetch").then((response) => {
                response.json().then((result) => {
                    setImageSrcList(result.resources)
                    setNumberOfImages(result.resources.length)
                    setLoading(false)
                })
            }
            )
        }
    }, [loading, imageSrcList, numberOfImages])

    if (window.sessionStorage.getItem("loggedIn") !== "TRUE") {
        return <Navigate to="/" />
    }

    function previousImage() {
        let new_ind = focusedIndex - 1;
        setFocusedIndex(new_ind);
        setFocusedSrc(imageSrcList[new_ind].src)
    }

    function nextImage() {
        let new_ind = focusedIndex + 1;
        setFocusedIndex(new_ind);
        setFocusedSrc(imageSrcList[new_ind].src)
    }

    function focusView() {
        if (focusedSrc === "") { return (<></>) }
        else {
            return (
                <div className="focus-container">
                    <div className="dimmer" onClick={() => { setFocusedSrc(""); setFocusedIndex(-1) }} />
                    {(focusedIndex > 0) ? <div className="button prev" onClick={previousImage}>&lt;</div> : <></>}
                    <img className="focus-image" src={focusedSrc} alt="Kruthi and Nick" />
                    {(focusedIndex < numberOfImages) ? <div className="button next" onClick={nextImage}>&gt;</div> : <></>}
                    <div className="button exit" onClick={() => { setFocusedSrc(""); setFocusedIndex(-1) }}>X</div>
                </div>
            )
        }
    }

    function ImageList() {
        return imageSrcList.map((object: any, index: number) => {
            return (
                <li>
                    <img className="gallery-image" src={object.src} alt="Kruthi and Nick" onClick={() => {
                        setFocusedSrc(object.src);
                        setFocusedIndex(index);
                    }} />
                </li>
            )
        })
    }

    if (loading) {
        return <progress/>
    }

    return (
        <div className="gallery-container">
            {focusView()}
            <ul className="image-gallery">
                {ImageList()}
            </ul>
        </div>
    )
}

export default Gallery;